import { render } from "./decorator.vue?vue&type=template&id=9ff711f4&ts=true"
import script from "./decorator.vue?vue&type=script&lang=ts"
export * from "./decorator.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__